import * as $ from 'jquery';
import 'jquery-colorbox';

export default function init() {

    // get all product rows with image galleries
    var productRowsWithImages = $('.product-row__flex-wrapper .product-row__image').has('a');

    let resizeInterval: number = undefined;
    
    // loop over all rows with images and create colorbox galleries
    productRowsWithImages.each(function() {
        let galleryId = $(this).attr('data-gallery-id');
        let gallerySelector = '.product-row__galleryImage' + galleryId;
        $(this).children(gallerySelector).each(function() {
            $(this).colorbox({
                rel: galleryId,
                // inline: true,
                transition: 'none',
                // initialWidth: '200',
                // initialHeight: '200',
                width: '100%',
                height: '100%',
                scalePhotos: false,
                // height: '90%',
                // maxWidth: '90%',
                // maxHeight: '90%',
                fixed: true,
                reposition: true,
                close: 'Close <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.33 16.84">\
                        <path fill="#384436" d="M13.46 15.34l1.48-1.49 15.35 15.34-1.49 1.49z" transform="translate(-12.96 -13.85)"/>\
                        <path fill="#384436" d="M13 29.2l15.31-15.34 1.48 1.48-15.34 15.35z" transform="translate(-12.96 -13.85)"/>\
                    </svg>',
                previous: '\
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 332.57 570.29">\
                        <path fill="#384436" d="M332.57 47.43a19.69 19.69 0 01-5.72 13.14L102.28 285.14l224.57 224.57a18 18 0 010 26.29l-28.57 28.57a18 18 0 01-26.28 0L5.71 298.29a18 18 0 010-26.29L272 5.71a18 18 0 0126.28 0l28.57 28.57a18.61 18.61 0 015.72 13.15z"/>\
                    </svg>\
                    <span>prev</span>',
                next: '\
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 332.57 570.28">\
                        <path fill="#384436" d="M332.57 285.14a19.75 19.75 0 01-5.71 13.15L60.57 564.57a19.69 19.69 0 01-13.14 5.72 19.71 19.71 0 01-13.15-5.72L5.71 536A18.59 18.59 0 010 522.86a19.72 19.72 0 015.71-13.14l224.57-224.57L5.71 60.57a18 18 0 010-26.28L34.28 5.72A19.71 19.71 0 0147.43 0a19.69 19.69 0 0113.14 5.72L326.86 272a19.73 19.73 0 015.71 13.15z" />\
                    </svg>\
                    <span>next</span>',
                onOpen: () => {
                    document.querySelector('html').classList.add('lockScroll');
                },
                onComplete: () => {
                    // Images may not be loaded and when when listening for them to be loaded, calling resize() still doesn't
                    // always work, so we have to fallback to using a setInterval to be safe and ensure everything works.

                    // Resize once now
                    $.colorbox.resize();

                    // and start interval to refresh every second until lightbox is closed
                    if (resizeInterval !== undefined) {
                        clearInterval(resizeInterval);
                    }
                    setTimeout(() => $.colorbox.resize(), 200);
                    setTimeout(() => $.colorbox.resize(), 500);
                    resizeInterval = setInterval(() => $.colorbox.resize(), 1000);
                },
                onClosed: () => {
                    document.querySelector('html').classList.remove('lockScroll');

                    // Stop interval
                    clearInterval(resizeInterval);
                    resizeInterval = undefined;
                }
            });
        });
    });
}
